export const sector = {
  name_one: "secteur",
  name_other: "secteurs",
  add: {
    label: "Ajouter un secteur",
  },
  delete: {
    label: "Supprimer le secteur",
  },
  form: {
    associateLocationWith: "Associer ce secteur avec",
    edit: {
      label: "Modifier le secteur",
    },
    informations: "Informations du secteur",
  },
};
